import { render, staticRenderFns } from "./detailright.vue?vue&type=template&id=6072ffda&scoped=true&"
import script from "./detailright.vue?vue&type=script&lang=js&"
export * from "./detailright.vue?vue&type=script&lang=js&"
import style0 from "./detailright.vue?vue&type=style&index=0&id=6072ffda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6072ffda",
  null
  
)

export default component.exports